var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIconTfi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/\uEA15") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-custom-UI---TFI",
    transform: "translate(-326.000000, -19.000000)",
    fill: "#002C56",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.68,23.88 L343.653333,25.9066667 L339.493333,21.7466667 L341.52,19.72 C341.733334,19.5066656 341.995554,19.4 342.306667,19.4 C342.617779,19.4 342.879999,19.5066656 343.093333,19.72 L345.68,22.3066667 C345.893334,22.5200011 346,22.7822207 346,23.0933333 C346,23.404446 345.893334,23.6666656 345.68,23.88 Z M326,35.24 L338.293333,22.9466667 L342.453333,27.1066667 L330.16,39.4 L326,39.4 L326,35.24 Z",
    id: "\\uEA15"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconTfi);
export default __webpack_public_path__ + "static/media/edit_icon_tfi.265a9613ec38d45de609994c42a2a2fd.svg";
export { ForwardRef as ReactComponent };